import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  DepreciationRunResult,
  DepreciationScheduleRow,
} from '../interfaces/fixedAsset/fixedAssetReport.interface';

export const FixedAssetDepreciationService = {
  // institutionId is the path var; period goes in the body
  run: async (institutionId: string, period: string): Promise<DepreciationRunResult> =>
    (await axios.post(ENDPOINTS.FIXED_ASSET_DEPRECIATION.RUN(institutionId), { period })).data,
  scheduleByAsset: async (assetId: string): Promise<DepreciationScheduleRow[]> =>
    (await axios.get(ENDPOINTS.FIXED_ASSET_DEPRECIATION.SCHEDULE_BY_ASSET(assetId))).data,
};
